import { Component } from '@angular/core';

@Component({
  selector: 'tgt-divider',
  standalone: true,
  imports: [],
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss'
})
export class DividerComponent {

}
